import React, {Component} from 'react'

class RadioGroupItem extends Component {
    constructor(props) {
      super(props);
      this.state = {
        answerIds: [],
        activeSelection: null,
        radioId: this.hashCode(this.props.data.text) + Math.random()
      };
    }

    componentDidMount = () => {
        var newObj = [];
        this.props.data.answerOptions.map((x) => {
            newObj.push({
                "id": x.id,
                "text": x.text
            });
        })
        this.setState({ answerIds: newObj });
        
        
        if(this.props.prepop && this.props.prepop.hasOwnProperty('questions')) {
            let matched = this.props.prepop.questions.find(item => {
                return this.props.data.id === item.id
            })

            if(matched) {
                let foundItem = this.props.data.answerOptions.find(item => {
                        return matched.answers[0].id === item.id
                    })

                
                this.setActive(null, foundItem)

                this.setState({
                    activeSelection: foundItem.text
                })
            }
        }

    }

    mapValueToId = (value) => {
        if (this.state.answerIds.length) {
            switch (value) {
                case "Yes":
                    return this.state.answerIds[0].id
                case "No":
                    return this.state.answerIds[1].id
            }
        }
    }
  
    hashCode = (value) => {
        return value.split("").reduce(function(a,b){a=((a<<5)-a)+b.charCodeAt(0);return a&a},0);              
    }

    setActive(e, item) {
        let text = e !== null ? e.target.innerText : item.text

        var data = {
            "id": this.props.data.id,
            "answers": [
                {
                    "id": this.mapValueToId(text),
                    "text": text
                }
            ]
        };
        this.props.activeItem(data);
        this.setState({
            activeSelection: text
        })
    }

    render() {
        
        return (
            <div className='clearfix full-width'>
                {this.props.questionLength > 1 ? <h4 className='custom-radiogroup-header'>{this.props.data.text}</h4> : undefined }
                <div className='custom-radiogroup-wrapper'>
                    <input className='custom-radiogroup' name={this.state.radioId} key={this.state.radioId + '-yes'} id={this.state.radioId + '-yes'} type='radio' value='yes' onChange={this.setActive.bind(this)} checked={this.state.activeSelection === 'Yes'} />
                    <label onClick={this.setActive.bind(this)} htmlFor={this.state.radioId + '-yes'}>Yes</label>
                </div>
                <div className='custom-radiogroup-wrapper fl-right'>
                    <input className='custom-radiogroup' name={this.state.radioId} key={this.state.radioId + '-no'} id={this.state.radioId + '-no'} type='radio' value='no' onChange={this.setActive.bind(this)} checked={this.state.activeSelection === 'No'} />
                    <label onClick={this.setActive.bind(this)} htmlFor={this.state.radioId + '-no'}>No</label>
                </div>
            </div>
        );
    }
}

export default class RadioGroup extends Component {
    constructor (props) {
        super(props)
        this.state = {
            activeItem: null,
            questionArray: []
        };
    }

    componentDidMount = () => {
       // console.log('didmount: radio group item %o prepop %o', this.props.data, this.props.prepop)

    }

    activeItem = (item) => {
        //console.log('radio group item %o', item)
        if (item) {
            var newArray = this.state.questionArray;
            newArray.map((x, i) => {
                if (item.id === x.id) {
                    return newArray.splice(i,1, item);
                }
            })
            newArray.push(item)
            this.setState({ questionArray: newArray });

            this.setState({ activeItem: item });
            var newData = {
                "questionNumber": this.props.questionNumber,
                "valid": true,
                "id": this.props.data.id,
                "questions": this.state.questionArray
            };
            this.props.manageFormData(newData)
        }
    }

    render() {
        //debugger
        var questionLength = this.props.data.questions.length;
        var output = this.props.data.questions.map((x,i) => {
            if(this.props.secondaryQuestion && i === 0) {
                return null
            }
            
            return (
                <RadioGroupItem data={x} key={i} activeItem={this.activeItem} questionLength={questionLength} prepop={this.props.prepop} />
            )
        })
        //console.log('radio group props %o', this.props)
    return (
        <div className={(this.props.secondaryQuestion) ? 'secondaryQuestion': ''} id={this.props.data.id}>
            { (!this.props.secondaryQuestion) ? (<h3 className='question-title'>{this.props.data.title}</h3>) : null}
            {output}
        </div>
    )
  }
}
